export default {
    wizardType: "INTERCOM",

    getConnectionParams: (type, model) => ({
        ApiKey: model.get("apiKey"),
        AccessToken: model.get("accessToken"),
        AuthMode: model.get("authMode"),
    }),
};

